<div class="view-component">
  <nz-spin class="screen-spin" [nzSpinning]="screenLoading" nzSize="large">
  <div class="content">
    <div class="cardaccordion">
      <nz-collapse class="filter-collapse" [nzBordered]="false">
        <nz-collapse-panel [nzHeader]="filterHeader" [nzExtra]="filterActions" [nzActive]="expanded" (nzActiveChange)="$event ? open() : close()">

          <div [hidden]="showFilter">
            <div class="filterclass tem-field">
              <label class="tem-field-label">Selecionar um filtro</label>
              <nz-select class="filter-select" [formControl]="filterSelect" nzMode="multiple" nzPlaceHolder="Selecionar um filtro" [compareWith]="compareFilter" nzAllowClear>
                <nz-option *ngFor="let filter of filters" [nzValue]="filter" [nzLabel]="filter.name"></nz-option>
              </nz-select>
            </div>
          </div>

          <filterview *ngIf="showFilter" [allFields]="dataRowColumns" #filter [editing]="editing">
          </filterview>

        </nz-collapse-panel>
      </nz-collapse>

      <ng-template #filterHeader>
        <span class="filter-title"><nz-icon nzType="filter"></nz-icon><b>Filtros</b></span>
      </ng-template>
      <ng-template #filterActions>
        <span class="filter-actions" (click)="$event.stopPropagation()">
          <button nz-button nzSize="small" nzType="primary" (click)="aplicar($event)" [hidden]="showFilter">Aplicar</button>
          <button nz-button nzSize="small" (click)="novo($event)" [hidden]="showFilter">Novo</button>
          <button nz-button nzSize="small" (click)="editar($event)" [hidden]="showFilter">Editar</button>
          <button nz-button nzSize="small" nzDanger (click)="excluir($event)" [hidden]="showFilter">Excluir</button>
          <button nz-button nzSize="small" nzType="primary" (click)="salvar($event)" [hidden]="!showFilter">Salvar</button>
          <button nz-button nzSize="small" (click)="cancelar($event)" [hidden]="!showFilter">Cancelar</button>
        </span>
      </ng-template>
    </div>

    <div class="data-info">
      <div class="chip-list">
        <nz-tag *ngFor="let col of columns" nzMode="checkable" [nzChecked]="fieldSelected.indexOf(col.name) > -1" (nzCheckedChange)="selectedFilter($event,col)">
          {{col.desc}}
        </nz-tag>
      </div>
      <div class="flex-spacer"></div>
      <div *ngIf="fastFilter.length > 0" class="fast-filter">
        <div *ngFor="let item of fastFilter" class="fast-filter-detail">
          <nz-select class="fast-filter-select" [(ngModel)]="item.checked" nzMode="multiple" [nzPlaceHolder]="item.name" [nzMaxTagCount]="2">
            <nz-option *ngFor="let condition of item.conditions" [nzValue]="condition.name" [nzLabel]="condition.name" nzCustomContent>
              <div class="fast-filter-option">
                <span class="fast-filter-option-icon">
                  <generic-icon *ngIf="condition.svgIcon!=null" [iconName]="condition.svgIcon" type="custom"></generic-icon>
                  <generic-icon *ngIf="condition.icon!=null" [iconName]="condition.icon" type="google"></generic-icon>
                </span>
                <b>{{condition.name}}</b>
              </div>
            </nz-option>
          </nz-select>
        </div>
      </div>
      <div class="vl"></div>
      <button nz-button nzType="primary" nzShape="circle" (click)="copyConfiguration()" nz-tooltip="Copiar configuração" class="copy-button">
        <nz-icon nzType="copy"></nz-icon>
      </button>
      <div class="vl"></div>
      <div class="paginator" *ngIf="showPaginator">
        <div class="info">Linhas: {{( rows | async).length }} de {{ totalLines }}</div>
        <div class="cancelar" (click)="cancelarLoading()">Cancelar</div>
      </div>
      <div class="info data"  *ngIf="!showPaginator" nz-tooltip="Total de Linhas">
          <div class="total-lines">{{(rows | async).length}}</div>
      </div>
    </div>
    <div class="filterclass2">
        <nz-input-group [nzPrefix]="searchPrefix">
          <input nz-input (keyup)="updateFilter($event)" [placeholder]="filtroStr" [disabled]="!inputEnable">
        </nz-input-group>
        <ng-template #searchPrefix><nz-icon nzType="search"></nz-icon></ng-template>
    </div>

    <div class="table-relative">
      <nz-spin class="items-spin" [nzSpinning]="itemsLoading" nzSize="large">
      <div [ngClass]="{ 'tableclass-opened' : opened, 'tableclass-closed':!opened}" *ngIf="(temp|async).length > 0"  >
        <cdk-virtual-scroll-viewport  itemSize="100" minBufferPx="800" maxBufferPx="1200" class="innertable" >
          <div *cdkVirtualFor="let row of (temp | async); let i=index;trackBy: trackByFn;" (click)="clickRow(row,$event)" class="classe-border">
              <cardview [cardrow]="row"  (tableContextmenu)="onTableContextMenu($event)"  [options]="options" (action)="refresh(0)" [tableName]="tableName" [userConfig]="userConfig">
                <ng-container subtitle [ngTemplateOutlet]="cardsubtitle" [ngTemplateOutletContext]="{$implicit:row}"></ng-container>
                <ng-container complemento [ngTemplateOutlet]="cardcustom" [ngTemplateOutletContext]="{$implicit:row}"></ng-container>
              </cardview>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
      <div *ngIf="(temp|async).length == 0" class="no-record">
          <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="'Não encontrado nenhum resultado.'"></nz-empty>
      </div>
      </nz-spin>
      <div class="add-button" *ngIf="canInsert && addButtonAction!=null">
        <button nz-button nzType="primary" nzShape="circle" nzSize="large" nz-tooltip="Adicionar" (click)="addButtonActionClick('inserindo',userConfig)">
          <nz-icon nzType="plus"></nz-icon>
        </button>
      </div>
    </div>

  </div>
  </nz-spin>
</div>
